import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as zc from '@dvsl/zoomcharts';

@Component({
  selector: 'app-timechart',
  templateUrl: './timechart.component.html',
  styleUrls: ['./timechart.component.css']
})
export class TimechartComponent implements AfterViewInit {

  @Input() chartID: string;
  @Input() settings: string;
  zc: any = zc;
  chart: any;
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const TimeChart = this.zc.TimeChart;
    this.chart = new TimeChart(this.settings);
  }

}
